/** The dealer (user request 2026-10-01): a person in Areena's jersey – the emblem on the chest, yellow trim. */
export function Dealer(props: { class?: string }) {
  return (
    <svg class={`bj-dealer ${props.class ?? ''}`} viewBox="0 -4 210 154" aria-hidden="true">
      <defs>
        <linearGradient id="bj-ring" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stop-color="#5cc8ff" />
          <stop offset="1" stop-color="#a78bfa" />
        </linearGradient>
      </defs>
      <path d="M30 150 Q34 92 72 82 L92 78 Q105 92 118 78 L138 82 Q176 92 180 150 Z" fill="#1b2442" stroke="#2c3a66" stroke-width="2" />
      <path d="M92 78 Q105 96 118 78" fill="none" stroke="#facc15" stroke-width="5" stroke-linecap="round" />
      <path d="M44 112 L36 150 M166 112 L174 150" stroke="#facc15" stroke-width="5" />
      <g transform="translate(91,100) scale(0.6)">
        <path d="M30.5 5.2A20 20 0 1 1 17.5 5.2" fill="none" stroke="url(#bj-ring)" stroke-width="4" stroke-linecap="round" />
        <path d="M24 9 L13 37 M24 9 L35 37" stroke="#e8ecf6" stroke-width="4" stroke-linecap="round" />
        <path d="M24 22.5l1.6 3.4 3.7.4-2.8 2.5.8 3.7-3.3-1.9-3.3 1.9.8-3.7-2.8-2.5 3.7-.4z" fill="#facc15" />
      </g>
      <path d="M95 62 L95 80 Q105 86 115 80 L115 62 Z" fill="#e3a77c" />
      <path d="M95 70 Q105 76 115 70 L115 64 L95 64 Z" fill="#c98c62" opacity=".55" />
      <ellipse cx="79.5" cy="41" rx="4.2" ry="7.5" fill="#e9b088" />
      <ellipse cx="130.5" cy="41" rx="4.2" ry="7.5" fill="#e9b088" />
      <path d="M82 28 C82 13 93 5 105 5 C117 5 128 13 128 28 L128 42 C128 56 121 67 113 72 C109 74.5 101 74.5 97 72 C89 67 82 56 82 42 Z" fill="#f2c29b" />
      <path d="M86 56 C90 65 96 71 101 73 C105 74.5 109 74 113 72 C109 76 101 76.5 97 74 C92 71 88 64 86 56 Z" fill="#dca07a" opacity=".55" />
      <path d="M80.5 33 C78 12 92 1.5 106 2 C121 2.5 132 12 129.5 33 C128 24 123 18 116 15.5 C110 21 98 22.5 88 20 C84.5 23.5 82 28 80.5 33 Z" fill="#3b2a1a" />
      <path d="M88 20 C96 21.5 108 20 116 15.5 C108 16.5 98 16 92 14 Z" fill="#5a3f27" opacity=".7" />
      <path d="M89 33.5 Q95 30.5 101 33 M109 33 Q115 30.5 121 33.5" stroke="#3b2a1a" stroke-width="2.4" fill="none" stroke-linecap="round" />
      <g class="bj-eyes">
        <ellipse cx="95.5" cy="40" rx="4.4" ry="2.9" fill="#fff" />
        <ellipse cx="114.5" cy="40" rx="4.4" ry="2.9" fill="#fff" />
        <circle cx="96" cy="40" r="2.1" fill="#3b2a1a" />
        <circle cx="114" cy="40" r="2.1" fill="#3b2a1a" />
      </g>
      <path d="M104.5 41 Q102.2 50 103.5 52.3 Q105.5 53.6 108 52.3" stroke="#c98c62" stroke-width="1.6" fill="none" stroke-linecap="round" />
      <path d="M97.5 59 Q105 64.5 112.5 59" stroke="#9a4b33" stroke-width="2.2" fill="none" stroke-linecap="round" />
      <ellipse cx="90" cy="50" rx="4" ry="2.4" fill="#f4a5a5" opacity=".35" />
      <ellipse cx="120" cy="50" rx="4" ry="2.4" fill="#f4a5a5" opacity=".35" />
    </svg>
  );
}

/** Areena's logo and name printed faintly into the felt, the size of the table (user request 2026-10-01). */
export function FeltMark() {
  return (
    <svg class="bj-mark" viewBox="0 0 560 120" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
      <g transform="translate(4,6) scale(2.25)" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round">
        <path d="M30.5 5.2A20 20 0 1 1 17.5 5.2" />
        <path d="M24 9 L13 37 M24 9 L35 37" />
        <path d="M24 22.5l1.6 3.4 3.7.4-2.8 2.5.8 3.7-3.3-1.9-3.3 1.9.8-3.7-2.8-2.5 3.7-.4z" fill="currentColor" stroke="none" />
      </g>
      <text x="128" y="86" fill="currentColor" font-size="84" font-weight="800" textLength="424" lengthAdjust="spacing">AREENA</text>
    </svg>
  );
}
